import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initializeDataLayer } from '../utils/gtm';

// Component for tracking page views inside Router context
const GTMPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize dataLayer
    initializeDataLayer();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    const pageTitle = document.title;
    const pageUrl = window.location.href;
    
    trackPageView(pageUrl, pageTitle);
  }, [location]);

  return null; // This component doesn't render anything
};

export default GTMPageTracker;
